import { CSSProperties } from 'react';

export const inputContainerStyle: CSSProperties = {
  position: 'absolute',
  marginTop: '75%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
};

export const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  backgroundColor: 'var(--background-white)'
};

export const heightTextStyle: CSSProperties = {
  fontSize: '24px',
  fontWeight: '600',
  marginBottom: '20px',
  color: '#1A1A1A',
  letterSpacing: '-0.3px'
};

export const rangeContainerStyle: CSSProperties = {
  width: '80%',
  padding: '20px 0'
};

export const trackStyle: CSSProperties = {
  height: '3px',
  width: '100%',
  borderRadius: '3px'
};

export const thumbStyle: CSSProperties = {
  height: '32px',
  width: '32px',
  backgroundColor: '#fff',
  border: '2px solid #1A1A1A',
  borderRadius: '50%',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  outline: 'none',
  cursor: 'pointer'
};

export const resetButtonContainerStyle: CSSProperties = {
  marginTop: '40px'
};

export const resetButtonStyle: CSSProperties = {
  border: 'none',
  background: 'rgba(0, 0, 0, 0.06)',
  borderRadius: '12px',
  fontSize: '15px',
  fontWeight: '500',
  color: '#1A1A1A',
  fontFamily: 'var(--font-primary)',
  padding: '12px 20px',
  cursor: 'pointer'
};
